import { IBlogPostFields } from 'global';
import { getMagazineUrl } from 'modules/magazine/util';
import Head from 'next/head';
import React from 'react';
import { useRegion } from 'hooks/use-region';
import { jsonLdScriptProps } from 'react-schemaorg';
import { Article } from 'schema-dts';

type ArticleSchemaPropType = Pick<
  IBlogPostFields,
  'title' | 'handle' | 'publishDate' | 'mainCategory' | 'subCategory' | 'author' | 'body'
>;

const ArticleSchemaMarkup: React.FC<ArticleSchemaPropType> = ({
  author,
  body,
  subCategory,
  mainCategory,
  handle,
  title,
  publishDate,
}) => {
  const images = body.content
    .filter((v) => v.nodeType === 'embedded-entry-block')
    .map((s) => s.data.target.fields)
    .filter((v) => v.image)
    .map((r) => r.image.fields.file.url)
    .map((url) => `https:${url}`);

  const region = useRegion();

  return (
    <Head>
      <script
        {...jsonLdScriptProps<Article>({
          '@context': 'https://schema.org',
          '@type': 'Article',
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': getMagazineUrl(
              {
                subCategory: subCategory.fields,
                mainCategory: mainCategory.fields,
                blogPost: handle,
              },
              true,
              region
            ),
          },
          headline: `${title}`,
          image: `${images}`,
          author: {
            '@type': 'Person',
            name: `${author.fields.name}`,
            ...(author.fields.handle && {
              url: getMagazineUrl({ author: author.fields }, true, region),
            }),
          },
          publisher: {
            '@type': 'Organization',
            name: 'Pets Deli',
            logo: {
              '@type': 'ImageObject',
              url: 'https://www.petsdeli.de/images/petsdeli-logo.svg',
            },
          },
          datePublished: `${publishDate}`,
        })}
      />
    </Head>
  );
};

export default ArticleSchemaMarkup;
